import ProviderInvited from './provider-invited';

export default ProviderInvited;
